import React from 'react';
import classnames from 'classnames';
import { Translate } from 'react-localize-redux';

class SharingGroupRemovalConfirmation extends React.Component {
    render() {
        return (<>
            <Translate id='User.SharingGroups.RemovalPopupText' options={{ renderInnerHtml: true }} />
            <div className='modal-inner-buttons' style={{ marginTop: '1em' }}>
                <button className={classnames('bb-button bold-bb-button is-primary gradient-1-gray', { 'is-square': localStorage.locales_button_style === 'square' })} onClick={_ => typeof this.props.no === 'function' && this.props.no()}>
                    <Translate id='Common.No' />
                </button>
                <button className={classnames('bb-button bold-bb-button is-primary gradient-1', { 'is-square': localStorage.locales_button_style === 'square' })} onClick={_ => typeof this.props.yes === 'function' && this.props.yes()}>
                    <Translate id='Common.Yes' />
                </button>
            </div>
        </>)
    }
}

export default SharingGroupRemovalConfirmation;